var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.332 7H11.7852C8.59516 7 6 9.59592 6 12.7869V23.3537C6 26.5446 8.59516 29.1406 11.7852 29.1406H23.332C26.522 29.1406 29.1172 26.5446 29.1172 23.3537V12.7869C29.1172 9.59592 26.522 7 23.332 7ZM8.04083 12.7869C8.04083 10.7219 9.72082 9.04143 11.7852 9.04143H23.332C25.3964 9.04143 27.0764 10.7219 27.0764 12.7869V23.3537C27.0764 25.4186 25.3964 27.0991 23.332 27.0991H11.7852C9.72082 27.0991 8.04083 25.4186 8.04083 23.3537V12.7869Z",
    fill: "#100A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5589 23.4516C20.5254 23.4516 22.9401 21.0375 22.9401 18.0688C22.9401 15.1002 20.5267 12.686 17.5589 12.686C14.5912 12.686 12.1777 15.1002 12.1777 18.0688C12.1777 21.0375 14.5912 23.4516 17.5589 23.4516ZM17.5589 14.7288C19.401 14.7288 20.8993 16.2275 20.8993 18.0701C20.8993 19.9128 19.401 21.4115 17.5589 21.4115C15.7168 21.4115 14.2186 19.9128 14.2186 18.0701C14.2186 16.2275 15.7168 14.7288 17.5589 14.7288Z",
    fill: "#100A55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4382 13.5559C24.237 13.5559 24.8881 12.9059 24.8881 12.1056C24.8881 11.3052 24.2383 10.6553 23.4382 10.6553C22.638 10.6553 21.9883 11.3052 21.9883 12.1056C21.9883 12.9059 22.638 13.5559 23.4382 13.5559Z",
    fill: "#100A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.75e8278bf3e26f3c6a8d32746d7f191a.svg";
export { ForwardRef as ReactComponent };